import { applyDatabinding, Icon } from '@dynamic/ui';
import { FC } from 'react';
import styled from 'styled-components';

import { useActions, useIsMobile } from '#/hooks';
import { FooterInfo } from '#/service/config';
import { remify } from '#/service/utils';

interface StyledProps {
  $isMobile?: boolean;
}

const InfoContainer = styled.div<StyledProps>`
  font: var(--fontStyleFootnote);
  background-color: var(--pageSecondaryBackground);
  padding: ${remify(15)} ${remify(50)};
  display: flex;
  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
  justify-content: center;
`;

const Copyright = styled.div<StyledProps>`
  text-align: left;
  justify-content: flex-start;
  flex: 1;

  ${({ $isMobile }) =>
    $isMobile
      ? `white-space: break-spaces;
    text-align: center;
    padding: ${remify(5)} 0 ${remify(5)} 0;
    `
      : `overflow: hidden;
    text-overflow: ellipsis;
  `}
`;

const Socials = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
`;

const SocialItem = styled.button`
  margin: 0 ${remify(7.5)};

  background: none;
  border: none;
  color: inherit;
  outline: none;
  padding: 0;
  line-height: 100%;
  cursor: pointer;
`;

const Contact = styled.div<StyledProps>`
  text-align: right;
  justify-content: flex-end;
  flex: 1;

  ${({ $isMobile }) =>
    $isMobile
      ? `text-align: center;
    `
      : `overflow: hidden;
    text-overflow: ellipsis;
`}
`;

const Info: FC<FooterInfo> = ({ copyright, contact, socials }) => {
  const { handleAction } = useActions();
  const isMobile = useIsMobile();

  const parsedCopyright = applyDatabinding({
    value: copyright,
    context: {
      currentYear: new Date().getFullYear(),
    },
  });

  return (
    <InfoContainer $isMobile={isMobile}>
      {!isMobile && (
        <Copyright $isMobile={isMobile}>{parsedCopyright}</Copyright>
      )}
      <Socials>
        {socials.map(({ key, icon, action }) => (
          <SocialItem
            key={key}
            onClick={() => {
              handleAction(action);
            }}
          >
            <Icon key={key} name={icon} />
          </SocialItem>
        ))}
      </Socials>
      {isMobile && (
        <Copyright $isMobile={isMobile}>{parsedCopyright}</Copyright>
      )}
      <Contact $isMobile={isMobile}>{contact}</Contact>
    </InfoContainer>
  );
};

export default Info;
